import React from "react";
import DialogBase from "./DialogBase";

type PROPS = {
  title?: string;
  message?: string;
  close: () => void;
};

const MessageDialog: React.FC<PROPS> = (props) => {
  const open = !!props.message;
  const title = props.title ?? "";
  const message = props.message ?? "";

  return (
    <DialogBase modalIsOpen={open} title={title} close={props.close}>
      <div className="p-4 flex flex-col gap-4">
        <div className="whitespace-pre-line" dangerouslySetInnerHTML={{__html: message}}></div>
        <div className="flex justify-center">
          <button className="primary px-4 py-2" onClick={props.close}>
            OK
          </button>
        </div>
      </div>
    </DialogBase>
  );
};

export default MessageDialog;
